import React from 'react';
import styled from 'styled-components';
import { mediaQuery, typography } from '../../theme';
import { colors } from '../../theme/color';
import ShareIcon from '@mui/icons-material/IosShare';

type Props = {
  onClick: () => void;
};

export const ShareButton: React.FC<Props> = ({ onClick }) => (
  <ShareButtonLayout onClick={onClick}>
    <StyledShare /> <span>Jaa</span>
  </ShareButtonLayout>
);

const ShareButtonLayout = styled.button`
  border-radius: ${({ theme }) => theme.sizes?.borderRadius.round};
  background: ${colors.green.lighter(90)};
  color: ${colors.textSuccess};
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 4.6875rem;
  height: 2.5rem;
  margin-bottom: 8px;
  z-index: 3;

  &:hover {
    background: ${colors.green.lighter(70)};

    & path {
      fill: ${colors.green.darker(50)};
    }

    span {
      color: ${colors.green.darker(30)};
    }
  }

  &:focus {
    background: ${colors.green.lighter(90)};
    color: ${colors.textSuccess};
    outline: 2px solid ${colors.textSuccess};
  }

  span {
    ${typography.buttonStyle}
    padding-left:1px;
  }

  @media ${mediaQuery.medium} {
    background: white;
    color: black;
    position: absolute;
    top: 1.55em;
    right: 1.1em;
    margin-bottom: 0;

    &:hover {
      background: white;

      & path {
        fill: black;
      }

      span {
        color: black;
      }
    }

    &:focus {
      color: black;
      outline: none;
    }
  }
`;

const StyledShare = styled(ShareIcon)`
  font-size: 1em;

  & path {
    fill: ${colors.textSuccess};
  }

  @media ${mediaQuery.medium} {
    & path {
      fill: black;
    }
  }
`;
